import React, { Component } from 'react'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import PinCodeUpdateUI from './PinCodeUpdateUI.js'

class PinCodeUpdateSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: [],
      submitted: false,
      oldPinCode: '',
      newPinCode: '',
      reenterPinCode: '',
      oldPinCodeError: null,
      newPinCodeError: null,
      reenterPinCodeError: null
    }
  }

  render() {
    return (
      <PinCodeUpdateUI
        context={this.props.context}
        // text
        messageList={this.props.messageList}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        // state
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancel={this.props.onCancel} // added in ViewOrUpdateUI
        setErrorList={this.setErrorList}
        // old pin code
        oldPinCode={this.state.oldPinCode}
        oldPinCodeError={this.state.oldPinCodeError}
        onOldPinCodeChange={this.onOldPinCodeChange}
        setOldPinCodeError={this.setOldPinCodeError}
        // new pin code
        newPinCode={this.state.newPinCode}
        newPinCodeError={this.state.newPinCodeError}
        onNewPinCodeChange={this.onNewPinCodeChange}
        setNewPinCodeError={this.setNewPinCodeError}
        // reenter pin code
        reenterPinCode={this.state.reenterPinCode}
        reenterPinCodeError={this.state.reenterPinCodeError}
        onReenterPinCodeChange={this.onReenterPinCodeChange}
        setReenterPinCodeError={this.setReenterPinCodeError}
      />
    )
  }

  UNSAFE_componentWillMount() {
  }

  onOldPinCodeChange = (event) => {
    this.setState({oldPinCode: event.target.value})
  }

  setOldPinCodeError = (error) => {
    this.setState({oldPinCodeError: error})
  }

  onNewPinCodeChange = (event) => {
    this.setState({newPinCode: event.target.value})
  }

  setNewPinCodeError = (error) => {
    this.setState({newPinCodeError: error})
  }

  onReenterPinCodeChange = (event) => {
    this.setState({reenterPinCode: event.target.value})
  }

  setReenterPinCodeError = (error) => {
    this.setState({reenterPinCodeError: error})
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
  }

  onSubmit = (event) => {
    let submitted = this.state.submitted
    if (submitted)
      return
    console.log('calling server')
    this.setState({submitted: true})
    RestApiUtils.put(this.props.context,
      '/api/user/pinCode',
      this.onSubmitCallback, {
        oldPinCode: this.state.oldPinCode,
        newPinCode: this.state.newPinCode,
        reenterPinCode: this.state.reenterPinCode
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    this.setState({submitted: false})

    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
        switch(error.fieldName) {
          case 'oldPinCode':
            this.setOldPinCodeError(error.message)
            break;
          case 'newPinCode':
            this.setNewPinCodeError(error.message)
            break;
          case 'reenterPinCode':
            this.setReenterPinCodeError(error.message)
            break;
          default:
        }
      })
    }

    this.setErrorList(errorList)

    this.setState({successMsg: response.success})

    if (errorList.length === 0) {
      setTimeout(() => {
        this.props.onCancel()
      }, 2000);
    }
  }
}

export default PinCodeUpdateSF
